import { DEGREE_TYPES, PROGRAM_DROPDOWN } from "@/components/molecules/ProgramMenu/form-constants";

const SELECT_DEGREE = "Select Degree";
const SELECT_PROGRAM = "Select Program";

const degreeOptions = ["UG", "PG"];

const exlcudePrograms = [
  "BSc. (Hons.) in Information Technology",
  "MSc. in Information Technology",
  "MSc. Environmental Science",
];

const excludeProgramsOutsideIndia = [
  "BACHELOR OF ARTS (GENERAL) HINDI MEDIUM",
  "BACHELOR OF ARTS (GENERAL) IN KANNADA",
  "BACHELOR OF ARTS (GENERAL) IN MALAYALAM",
  "BACHELOR OF ARTS (GENERAL) IN TAMIL",
  "BACHELOR OF ARTS (GENERAL) IN TELUGU",
  "BACHELOR OF ARTS (HINDI MEDIUM)",
  "BACHELOR OF COMMERCE (GENERAL) HINDI MEDIUM",
  "BACHELOR OF COMMERCE (GENERAL) IN KANNADA",
  "BACHELOR OF COMMERCE (GENERAL) IN MALAYALAM",
  "BACHELOR OF COMMERCE (GENERAL) IN TAMIL",
  "BACHELOR OF COMMERCE (GENERAL) IN TELUGU",
];

const programsOptions = PROGRAM_DROPDOWN.filter(
  (e) => !exlcudePrograms.includes(e.title),
)
  .filter(
    (x: any) =>
      x.programType &&
      degreeOptions.indexOf(String(x.programType).toUpperCase()) > -1
  )
  .map((x: any) => x.title);

const precedentSelectedPrograms = (associatedPrograms: Array<ProgramDetails>) =>
  associatedPrograms.map((selectedProgram) =>
    selectedProgram.attributes.BasicDetails?.Heading.toUpperCase(),
  );

const getProgramId = ({
  associatedPrograms,
  program,
  isLandingPage,
}: {
  associatedPrograms: Array<ProgramDetails>;
  program: string;
  /**
   * When explicitly false (FAQ hub), resolve from PROGRAM_DROPDOWN by title.
   * When true/undefined (Home / HomeNew), resolve from associatedPrograms.
   */
  isLandingPage?: boolean;
}) => {
  if (isLandingPage === false) {
    return (
      PROGRAM_DROPDOWN.find(
        (e) =>
          String(e.title).toLowerCase() == String(program).toLowerCase(),
      )?.id || ""
    );
  }

  const found = associatedPrograms.find(
    (p) =>
      String(p.attributes.BasicDetails?.Heading).trim().toLowerCase() ===
      String(program).trim().toLowerCase(),
  );

  return found?.attributes.BasicDetails?.PROGRAM_ID || "";
};

/** FAQ hub program list: filter global PROGRAM_DROPDOWN by degree + geo. */
const filterGlobalProgramsByDegree = ({
  degree,
  countryCode,
}: {
  degree: string;
  countryCode?: string;
}) => {
  const list = PROGRAM_DROPDOWN.filter(
    (x: any) => x.programType == degree,
  ).map((x: any) => x.title);

  let finalProgramsList = list?.length ? list : programsOptions;

  if (countryCode && countryCode !== "IN") {
    finalProgramsList = finalProgramsList.filter(
      (x: any) => !excludeProgramsOutsideIndia.includes(x),
    );
  }

  return finalProgramsList;
};

const filterSelectedPrograms = ({
  associatedPrograms,
  degree = SELECT_DEGREE,
}: {
  associatedPrograms: Array<ProgramDetails>;
  degree: string;
}) => {
  return associatedPrograms.filter(
    (programOption) =>
      (programOption.attributes.BasicDetails?.ProgramType ===
        DEGREE_TYPES[degree]?.id ||
        degree == SELECT_DEGREE) &&
      !!programOption.attributes.BasicDetails?.Heading,
  );
};

const leadSquareApiCall = async (payload, form, ipStackDetails, tracking) => {
  return fetch("/api/salesforce.com/lead-create-new", {
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ipstack: ipStackDetails,
      form: { ...form, ...payload },
      meta: {
        ...tracking,
        utm_medium: tracking?.utm_medium || "request_a_callback",
      },
      mx_Enquery_Source: "Enquire",
    }),
  });
};

const leadSquareApiCallLpPage = async (payload, form, ipStackDetails, tracking) =>
  fetch("/api/salesforce.com/lead-create-lp-new", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ipstack: ipStackDetails,
      form: { ...form, ...payload },
      meta: {
        ...tracking,
        utm_medium: tracking?.utm_medium || "request_a_callback",
      },
      mx_Enquery_Source: "Enquire",
    }),
  });

const connectCounsellorApiCall = (status, form, ipStackDetails, tracking) => fetch("/api/connect-counsellor", {
  method: "POST",
  body: JSON.stringify({
    ipstack: ipStackDetails,
    form,
    meta: {
      ...tracking,
      utm_medium: tracking?.utm_medium || "request_a_callback",
    },
    status,
  }),
});

export {
  precedentSelectedPrograms,
  getProgramId,
  SELECT_DEGREE,
  SELECT_PROGRAM,
  filterSelectedPrograms,
  filterGlobalProgramsByDegree,
  degreeOptions,
  programsOptions,
  excludeProgramsOutsideIndia,
  leadSquareApiCall,
  connectCounsellorApiCall,
  leadSquareApiCallLpPage
};
